import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon11: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M13.594 0C14.37 0 15 .61 15 1.364v18.18c0 .39-.472.599-.776.344L7.5 14.238l-6.724 5.65c-.304.255-.776.046-.776-.343V1.364C0 .61.63 0 1.406 0h12.188Zm0 .91H1.406a.462.462 0 0 0-.468.454v17.185l6.255-5.257a.48.48 0 0 1 .614 0l6.255 5.257V1.364c0-.251-.21-.455-.468-.455Z"
      />
    </Svg>
  )
}
